import { IExerciseQuestionType } from '../exercises.interface';

/**
 * Returns the solution string for display purposes.
 * Uses solutionString if available, otherwise falls back to solution.
 * Falls solution ein Array ist (z.B. bei FillBlanks), wird es als Satz mit Leerzeichen ausgegeben.
 */
export function getDisplaySolution(question: IExerciseQuestionType): string {
  if (question.solutionString && typeof question.solutionString === 'string' && question.solutionString.trim() !== '') {
    return question.solutionString;
  }
  // Fallback: Wenn solution ein Array ist, gib es als Satz mit Leerzeichen zurück
  if (Array.isArray(question.solution)) {
    return question.solution.join(' ');
  }
  return String(question.solution);
} 